import React from 'react';
import Skeleton from '@ingka/skeleton';
import styled, { keyframes } from 'styled-components';

type Props = {
  loading: boolean;
  loadingStyle?: any;
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Animation = styled.div`
  animation: ${fadeIn} 0.2s ease-out;
`;

const withLoadingSkeleton = <P extends object>(
  Component: React.FunctionComponent<P & Props>
): React.FunctionComponent<P & Props> => ({ loading, loadingStyle, ...rest }: P & Props) => {
  return (
    <Animation>
      {loading ? (
        <Skeleton data-testid="loading-skeleton" style={{ ...loadingStyle }} />
      ) : (
        <Component {...(rest as any)} />
      )}
    </Animation>
  );
};

export default withLoadingSkeleton;
